import {graphql, useStaticQuery} from "gatsby";



export const useExpertises =( )=>{
  const data = useStaticQuery(graphql`
      {
          expertises {
              data {
                  color
                  display_name {
                      en
                      fr
                  }
                  id
                  order
                  subitems {
                      id
                      order
                      display_name {
                          en
                          fr
                      }
                  }
              }
          }
      }
  `)

  return  data.expertises.data  ;
}